import { drama } from '../../../constants/actionTypes';

const initState = {};

export default (state = initState, { type, entities, result, commentId, replyId,  hasMoreReplies, repliesCount }) => {
  switch (type) {
    case drama.FETCH_DRAMA_PINNED_COMMENTS_SUCCESS:
      return entities.comments ? { ...state, ...entities.comments } : state;

    case drama.FETCH_DRAMA_REPLIES_SUCCESS: {
      const oldComment = state[commentId];

      if (!oldComment) {
        return state;
      }

      const newComment = {
        ...oldComment,
        replies: [...oldComment.replies, ...result],
        localReplies: oldComment.localReplies.filter(replyId => !result.includes(replyId)),
        hasMoreReplies,
        repliesCount,
      };

      return { ...state, [commentId]: newComment }
    }

    case drama.POST_DRAMA_REPLY_SUCCESS: {
      const oldComment = state[commentId];

      if (!oldComment) {
        return state;
      }

      const newComment = {
        ...oldComment,
        localReplies: [...oldComment.localReplies, result],
      };

      return { ...state, [commentId]: newComment }
    }

    case drama.DELETE_DRAMA_REPLY_SUCCESS: {
      const oldComment = state[commentId];

      if (!oldComment) {
        return state;
      }

      const newRepliesCount = oldComment.replies.includes(replyId) ? oldComment.repliesCount - 1 : oldComment.repliesCount;

      const newComment = {
        ...oldComment,
        replies: oldComment.replies.filter(id => id !== replyId),
        localReplies: oldComment.localReplies.filter(id => id !== replyId),
        repliesCount: newRepliesCount,
      };

      return { ...state, [commentId]: newComment }
    }

    case drama.CLEAN_COMMENTS:
      return initState;

    default:
      return state;
  }
};
